import ApplicationController from './application';

export default class extends ApplicationController {
  static targets = ['wrapper']

  connect() {
    document.addEventListener('click', this.handleClick.bind(this));

    const radioButtons = this.wrapperTarget.querySelectorAll('input[name="personal_detail[rsa_status]"]');
    const selectedRadioButton = [...radioButtons].find(radioButton => radioButton.checked)?.id;

    this.#triggerToggle(selectedRadioButton)
  }

  handleClick(event) {
    this.#triggerToggle(event.target.id)
  }

  #triggerToggle(id) {
    const rsaOptions = [
      'personal_detail_rsa_status_1_born_in_sa',
      'personal_detail_rsa_status_2_registered_in_sa',
    ];
    const notRsa = 'personal_detail_rsa_status_3_not_sa';

    if (rsaOptions.includes(id)) {
      this.#updateCardVisibility(0); // Show RSA-specific card
    } else if (id === notRsa) {
      this.#updateCardVisibility(1); // Show Non-RSA card
    }
  }

  #updateCardVisibility(visibleIndex) {
    // Cache DOM elements
    const cardWrapper = document.querySelector('.rsa-card');
    const cardList = cardWrapper?.querySelectorAll('.c-card') || [];
    const cardActions = document.querySelectorAll('.rsa-action button');

    // Ensure elements exist
    if (!cardWrapper || cardList.length < 3 || cardActions.length < 2) return;

    // Unhide the card wrapper
    cardWrapper.classList.remove('hidden');

    // Toggle the first two cards together
    if (visibleIndex === 0) { // RSA Options Selected
      cardList[0].classList.remove('hidden');
      cardList[1].classList.remove('hidden');
      cardList[2].classList.add('hidden');
    } else if (visibleIndex === 1) { // Not RSA selected
      cardList[0].classList.add('hidden');
      cardList[1].classList.add('hidden');
      cardList[2].classList.remove('hidden');
    }

    // Show the appropriate actions by index (Assuming you only have actions for the first two cards)
    cardActions.forEach((action, index) => {
      action.classList.toggle('hidden', index !== visibleIndex);
    });
  }
}
